module.exports = __webpack_public_path__ + "static/media/zoomOut.3503426d.svg";